import React from 'react';
import { TransactionHistory } from '../components/Credits/TransactionHistory';

const TransactionsPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-base-content">Transaction History</h1>
        <p className="text-base-content/70 mt-2">View all your credit transactions and purchase history</p>
      </div>
      
      <div className="bg-base-100 rounded-lg shadow-lg p-6 border border-base-300">
        <TransactionHistory />
      </div>
    </div>
  );
};

export default TransactionsPage; 